import { FormField, Grid, Heading, Label, Paragraph, Textarea, TextButton } from '@zillow/constellation';
import { Controller, useFormContext } from 'react-hook-form';
import type { LeaseRenewalFormValues } from '../../../pages/TenantDrivenLeaseRenewal';
import { FIELD_IDS } from '../../../pages/TenantDrivenLeaseRenewal';
import { useLeaseWebApiHandler_getLease } from '@zg-rentals/ts-leasing-client-react-query';
import { getDefaultMessageText } from '../../../utils/formatters';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';

export function ReviewOrEditYourMessage() {
  const { leaseId } = useLeasingUrlParams();
  const { getValues, setValue } = useFormContext<LeaseRenewalFormValues>();
  const { data } = useLeaseWebApiHandler_getLease({ leaseId });
  const landlordEmail = data?.lease?.landlords[0].email || '';
  const landlordFirstName = data?.lease?.landlords[0].firstName || '';
  const landlordLastName = data?.lease?.landlords[0].lastName || '';
  const tenantFirstName = data?.lease.tenants[0].firstName ?? '';

  return (
    <Grid display="grid" gridTemplateColumns="repeat(12, 1fr)" gridColumn="1 / -1">
      <Grid gridColumnEnd={{ sm_lte: 'span 12', md: 'span 8', xl: 'span 6' }}>
        <Heading level={3} as="h2" marginBottom="sm" fontFamily="serif">
          Review or edit your message
        </Heading>
        <Paragraph marginBottom="md" color="text.secondary">
          This draft is based on your answers so far. Review and add any remaining details before sending it to your
          landlord.
        </Paragraph>
        <Controller
          name={FIELD_IDS.RENEWAL_PROPOSAL_MESSAGE}
          render={({ field: { value, onChange, onBlur } }) => {
            return (
              <FormField
                required
                label={<Label>Proposal message</Label>}
                control={
                  <Textarea
                    marginBottom="md"
                    rows={15}
                    resize="vertical"
                    maxLength={1000}
                    value={value}
                    onChange={onChange}
                    onBlur={() => {
                      if (!value || !value.trim()) {
                        setValue(
                          FIELD_IDS.RENEWAL_PROPOSAL_MESSAGE,
                          getDefaultMessageText({
                            leaseRenewalFormData: getValues(),
                            leaseInfo: { landlordFirstName, tenantFirstName },
                          }),
                        );
                      }

                      setValue(FIELD_IDS.RENEWAL_PROPOSAL_MESSAGE, value.trim());
                      onBlur();
                    }}
                  />
                }
              />
            );
          }}
        />
        <Heading level={6} as="h3">
          Will be sent to
        </Heading>
        <Paragraph>
          {landlordFirstName && landlordFirstName ? `${landlordFirstName} ${landlordLastName}` : ''}
        </Paragraph>
        <TextButton as="a" href={`mailto:${landlordEmail}`}>
          {landlordEmail}
        </TextButton>
      </Grid>
    </Grid>
  );
}
